import { NotificationsScreen } from "@/features/notifications/NotificationsScreen";

export default function NotificationsRoute() {
    return <NotificationsScreen />;
}
